import React, {lazy} from 'react';

const Signin = lazy(() => import('@crema/modules/auth/Signin'));
const ForgotPassword = lazy(
  () => import('@crema/modules/auth/ForgetPassword/ForgetPasswordJwtAuth'),
);
const ResetPasswordAwsCognito = lazy(
  () => import('@crema/modules/auth/ForgetPassword/ResetPasswordAwsCognito'),
);

export const authRouteConfig = [
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/forget-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordAwsCognito />,
  },
];
